module.exports = __webpack_public_path__ + "img/cover-1.5e43aad1.jpg";